var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86177 5.52827C3.12212 5.26792 3.54423 5.26792 3.80458 5.52827L7.99984 9.72353L12.1951 5.52827C12.4554 5.26792 12.8776 5.26792 13.1379 5.52827C13.3983 5.78862 13.3983 6.21073 13.1379 6.47108L8.47124 11.1377C8.34622 11.2628 8.17665 11.333 7.99984 11.333C7.82303 11.333 7.65346 11.2628 7.52843 11.1377L2.86177 6.47108C2.60142 6.21073 2.60142 5.78862 2.86177 5.52827Z",
    fill: "#4A5564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGrey);
export default __webpack_public_path__ + "static/media/chevron-down-grey.ecc2f17e7a7598b0c0b3dc7f4789e184.svg";
export { ForwardRef as ReactComponent };